import auth from './auth'

export default function installPlugins(app){

  // 认证对象
  app.config.globalProperties.$auth = auth

}
